 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML03_COPYRIGHT_PAGE from '@/components/html/03_Copyright_Page'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML01_FRONT_MATTER from '@/components/html/01_Front_Matter'
 import HTML04_CONTENTS from '@/components/html/04_Contents'
 import HTML05_PREFACE from '@/components/html/05_Preface'
 import HTML06_PART_ONE__PHILOSOPHY from '@/components/html/06_Part_One__PHILOSOPHY'
 import HTML07_CHAPTER_1__THE_ERRORS_OF_CONSTRU from '@/components/html/07_Chapter_1__The_Errors_of_Constru'
 import HTML08_CHAPTER_2__THE_PRETENCE_OF_KNOWL from '@/components/html/08_Chapter_2__The_Pretence_of_Knowl'
 import HTML09_CHAPTER_3__THE_PRIMACY_OF_THE_AB from '@/components/html/09_Chapter_3__The_Primacy_of_the_Ab'
 import HTML10_CHAPTER_4__TWO_TYPES_OF_MIND from '@/components/html/10_Chapter_4__Two_Types_of_Mind'
 import HTML11_CHAPTER_5__THE_ATAVISM_OF_SOCIAL from '@/components/html/11_Chapter_5__The_Atavism_of_Social'
 import HTML12_PART_TWO__POLITICS from '@/components/html/12_Part_Two__POLITICS'
 import HTML13_CHAPTER_6__THE_CONFUSION_OF_LANG from '@/components/html/13_Chapter_6__The_Confusion_of_Lang'
 import HTML14_CHAPTER_7__THE_CONSTITUTION_OF_A from '@/components/html/14_Chapter_7__The_Constitution_of_a'
 import HTML15_CHAPTER_8__ECONOMIC_FREEDOM_AND from '@/components/html/15_Chapter_8__Economic_Freedom_and'
 import HTML16_CHAPTER_9__LIBERALISM from '@/components/html/16_Chapter_9__Liberalism'
 import HTML17_CHAPTER_10__WHITHER_DEMOCRACY from '@/components/html/17_Chapter_10__Whither_Democracy'
 import HTML18_PART_THREE__ECONOMICS from '@/components/html/18_Part_Three__ECONOMICS'
 import HTML19_CHAPTER_11__THREE_ELUCIDATIONS_O from '@/components/html/19_Chapter_11__Three_Elucidations_o'
 import HTML20_CHAPTER_12__COMPETITION_AS_A_DIS from '@/components/html/20_Chapter_12__Competition_as_a_Dis'
 import HTML21_CHAPTER_13__THE_CAMPAIGN_AGAINST from '@/components/html/21_Chapter_13__The_Campaign_Against'
 import HTML22_CHAPTER_14__THE_NEW_CONFUSION_AB from '@/components/html/22_Chapter_14__The_New_Confusion_Ab'
 import HTML23_PART_FOUR__HISTORY_OF_IDEAS from '@/components/html/23_Part_Four__HISTORY_OF_IDEAS'
 import HTML24_CHAPTER_15__DR_BERNARD_MANDEVILL from '@/components/html/24_Chapter_15__Dr_Bernard_Mandevill'
 import HTML25_CHAPTER_16__ADAM_SMITH_S_MESSAGE from '@/components/html/25_Chapter_16__Adam_Smith_s_Message'
 import HTML26_CHAPTER_17__THE_PLACE_OF_MENGER from '@/components/html/26_Chapter_17__The_Place_of_Menger'
 import HTML27_CHAPTER_18__PERSONAL_RECOLLECTIO from '@/components/html/27_Chapter_18__Personal_Recollectio'
 import HTML28_CHAPTER_19__NATURE_V__NURTURE_ON from '@/components/html/28_Chapter_19__Nature_v__Nurture_On'
 import HTML29_CHAPTER_20__SOCIALISM_AND_SCIENC from '@/components/html/29_Chapter_20__Socialism_and_Scienc'
 import HTML30_POSTSCRIPT from '@/components/html/30_Postscript'
 import HTML31_NOTES from '@/components/html/31_Notes'
 import HTML31_NAME_INDEX from '@/components/html/31_Name_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/04_Contents",
 			"name" : "html/04_Contents",
 			"component" : HTML04_CONTENTS
 		},
 		{
 			"path" : "/html/05_Preface",
 			"name" : "html/05_Preface",
 			"component" : HTML05_PREFACE
 		},
 		{
 			"path" : "/html/06_Part_One__PHILOSOPHY",
 			"name" : "html/06_Part_One__PHILOSOPHY",
 			"component" : HTML06_PART_ONE__PHILOSOPHY
 		},
 		{
 			"path" : "/html/07_Chapter_1__The_Errors_of_Constru",
 			"name" : "html/07_Chapter_1__The_Errors_of_Constru",
 			"component" : HTML07_CHAPTER_1__THE_ERRORS_OF_CONSTRU
 		},
 		{
 			"path" : "/html/08_Chapter_2__The_Pretence_of_Knowl",
 			"name" : "html/08_Chapter_2__The_Pretence_of_Knowl",
 			"component" : HTML08_CHAPTER_2__THE_PRETENCE_OF_KNOWL
 		},
 		{
 			"path" : "/html/09_Chapter_3__The_Primacy_of_the_Ab",
 			"name" : "html/09_Chapter_3__The_Primacy_of_the_Ab",
 			"component" : HTML09_CHAPTER_3__THE_PRIMACY_OF_THE_AB
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js